import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import StatusForm from './StatusForm';
import { dateHelpers } from '../../../../../../helpers';
import DeleteModal from '../../../../../common/elements/DeleteModal';

class JobApplicationsInternalSingle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: null
        }
    }

    handleDelete = () => {
        this.props.deleteApplication(this.props.application.id)
        this.setState({ modal: null })
    }

    render() {

        const { application, statuses } = this.props;
        const todaysDate = new Date().getTime();

        return (

            <div className="table__row manage-jobs-item">
                <div className="manage-jobs-item__summary">
                    <div className="row">
                        <div className="col-xs-12 col-lg-4">
                            <div className="main__name">
                                <Link to={`/jobs/${application.id}`}>{application.title}</Link>
                            </div>
                            <div className="main__salary">
                                {application.salary}
                            </div>
                        </div>
                        <div className="col-xs-12 col-lg-2 col--date">
                            {
                                (new Date(application.end_date)).getTime() > todaysDate ?
                                    <span className="main__date">
                                        <span className="date__label">Closes </span>
                                        <span className="date__info">{dateHelpers.dateConverter(application.end_date)}</span>
                                    </span>
                                    :
                                    <span className="main__date--expired">
                                        <span className="date__label"><i className="fa fa-exclamation-triangle" /> Expired </span>
                                        <span className="date__info">{dateHelpers.dateConverter(application.end_date)}</span>
                                    </span>
                            }
                        </div>
                        <div className="col-xs-12 col-lg-5 col--status">
                            <StatusForm
                                statuses={statuses}
                                currentStatus={application.job_application.person_status}
                                key={application.id}
                                job_id={application.id}
                            />
                            <div className="current-status">
                                <small>Current: {application.job_application.person_application_status.name}</small>
                            </div>
                        </div>
                        <div className="col-xs-12 col-lg-1 col--remove">
                            <button className="btn btn-warning small" onClick={() => this.setState({ modal: 'yes' })} >
                                <i className="fa fa-times" />
                            </button>
                        </div>
                        <div>
                            {this.state.modal &&
                                <DeleteModal header='Are you sure?' message="This can't be undone." onClose={() => this.setState({ modal: null })} onDelete={this.handleDelete} />}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

JobApplicationsInternalSingle.propTypes = {
    deleteApplication: PropTypes.func,
    statuses: PropTypes.array,
    application: PropTypes.object
};

export default JobApplicationsInternalSingle


// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/elements/JobApplicationsInternalSingle.js